/* eslint-disable react-hooks/exhaustive-deps */
import { LOGOUT_ACTION } from '@/modules/pe-basic-module/data/actionTypes'
import actions from '@/modules/pe-basic-module/data/actions'
import LoginForm from "@/modules/pe-basic-module/views/profile/LoginForm"
import DayNightSwitcher from '@/modules/pe-basic-module/widgets/DayNightSwitcher'
import { Button, ContextMenu, ContextMenuContentProps, Menu, MenuDivider, MenuItem } from '@blueprintjs/core'
import { __ } from "@libs/utilities"
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { IState, IUser, useMainStore } from '../../settings/zustand'
import { DIALOG_SIZE } from '../interfaces/layouts'
import { ScalableDialog } from '../useful'
import { CopyTextMenuItem, ExtendedMenus, PasteTextMenuItem } from './ExtendMenu'

interface IContextMenuProps {
    children: JSX.Element | JSX.Element[] | null 
    onHideLogin: () => void
    contextMethods: any
}
const ContextMenuContainer = (props: IContextMenuProps) : JSX.Element => {
    const user: IUser = useMainStore((state: IState) => state.user )
    const isOpenLogin : boolean = useMainStore((state: IState) => state.isOpenLogin ) 
    const [isPressControl, setPressControl] = useState(false) 
    const navigate = useNavigate() 
    const setOpenLogin = (is: boolean) => {
        useMainStore.setState({isOpenLogin : is})
    }
    const pressControl = ( e:any ) => {
      if( e.key === "Control") setPressControl(true) 
    }
    const upControl = () => {
      setPressControl(false) 
    }
    const loginUser = () =>
    { 
        if( user.id ) {
            onLogout()
        }            
        else {
            setOpenLogin(!isOpenLogin)
        }		    
    }
    const onLogout = () => {
        actions(LOGOUT_ACTION, {})
        window.location.reload()
    }
    const onResult = () =>
    { 
        props.onHideLogin()
        window.location.reload()
    } 
    useEffect(() => {
        document.addEventListener("keydown", pressControl)
        document.addEventListener("keyup", upControl) 
        useMainStore.setState({ location: window.location.origin })
        return () => {
            document.removeEventListener("keydown", pressControl)
            document.removeEventListener("keyup", upControl)
        }
    }, [])
    const renderContent = React.useCallback(
        ( _props : ContextMenuContentProps) => { 
            const target : any = _props.mouseEvent?.target
            return <Menu>
                {
                    !!target && !target.getAttribute('data-hidden-context') &&
                        <>
                            <MenuItem text={__( "Back history" )} icon="arrow-left"  onClick={() => navigate(-1) }/> 
                            <MenuDivider />
                            <ExtendedMenus menuProps={_props} contextMethods={props.contextMethods} />
                            {/* <CopyTextMenuItem menuProps={_props} />
                            <PasteTextMenuItem menuProps={_props} />
                            <DayNightSwitcher type="buttons" className=" text-force-contrast "/>
                            <MenuDivider />*/}
                            <MenuItem text={__( user.id ? "Log out" : "Log in" )} icon="person" onClick={ loginUser }/>  
                        </>
                }
            </Menu> 
        },
        [],
    )
    return <ContextMenu
        className="h-100"
        disabled={isPressControl}
        content={renderContent}
    >
        <>
            {props.children}
        </>
        <ScalableDialog 
            onClose={ props.onHideLogin }
            isOpen={ isOpenLogin } 
            dialogSize={ DIALOG_SIZE.LITTLE } 
            portalClassName="z-index-10000"
        >
            <div className="p-4 row">
                <LoginForm onResult={onResult} onResultArgs={{}} />
            </div>
            <Button 
                className='position-absolute right top' 
                variant="minimal" 
                onClick={ props.onHideLogin } 
                icon="cross" 
            />
        </ScalableDialog> 
    </ContextMenu> 
}

ContextMenuContainer.propTypes = {}

export default ContextMenuContainer

